import { createAction, props } from '@ngrx/store';
import { PEEquipmentProduct, PEEquipmentFamily, PEEquipmentSelector, PEFitting, PEFilter, PEAccessorySelector, EquipmentType, PEFittingProduct } from 'src/app/models';
import { LookupValue } from 'src/app/models/lookup.model';

export const loadPipeSizes = createAction('[PE] Load PipeSizes');
export const loadPipeSizesSuccess = createAction('[PE] Load PipeSizes Success', props<{ pipeSizes: LookupValue[] }>());
export const loadPipeSizesFail = createAction('[PE] Load Pipesizes fail', props<{ error: any }>());

/**
 * @param {number} this is the id of the LookupType for size
 */
export const toggleSizeOnFilter = createAction('[PE] toggle size on filter', props<{ size: number }>());
export const updatePeFilter = createAction('[PE] update fitting selections', props<{ obj: Partial<PEFilter> }>());
export const toggleSelectedFitting = createAction('[PE] toggle active fitting', props<{ obj: PEFittingProduct }>());
export const clearActiveFittings = createAction('[PE] clear active fittings');


export const loadFittings = createAction('[PE] load PE fittings');
export const loadFittingsSuccess = createAction('[PE] load PE fittings success', props<{ fittings: PEFittingProduct[] }>());
export const loadFittingsFail = createAction('[PE] load PE fittings fail', props<{ error: any }>());

export const loadEquipmentFamilies = createAction('[PE] load equipment families');
export const loadEquipmentFamiliesSuccess = createAction('[PE] load equipment families success', props<{ families: PEEquipmentFamily[] }>());
export const loadEquipmentFamiliesFail = createAction('[PE] load equipment families fail', props<{ error: any }>());

export const updateEquipmentSelections = createAction('[PE] update equipment selections', props<{ obj: Partial<PEEquipmentSelector> }>());

export const selectEquipment = createAction('[PE] select active equipment', props<{ partNumber?: string, equipmentType: EquipmentType }>());
export const loadEquipment = createAction('[PE] load PE equipment');
export const loadEquipmentSuccess = createAction('[PE] load PE equipment Success', props<{ equipment: PEEquipmentProduct[] }>());
export const loadEquipmentFail = createAction('[PE] load PE equipment Fail', props<{ error: any }>());

export const updateAccessorySelections = createAction('[PE] update equipment accessories', props<{ obj: Partial<PEAccessorySelector> }>());

export const loadAccessory = createAction('[PE] load PE Accessory');
export const loadAccessorySuccess = createAction('[PE] load PE Accessories Success', props<{ accessories: PEEquipmentProduct[] }>());
export const loadAccessoryFail = createAction('[PE] load PE Accessories Fail', props<{ error: any }>());

export const toggleActiveAccessory = createAction('[PE] set active accessory', props<{ partNumber: string }>());

export const exportPDF = createAction('[PE] export to pdf');
export const exportPDFSuccess = createAction('[PE] export to pdf success');
export const exportPDFFail = createAction('[PE] export to pdf fail', props<{ error: any }>());

export const exportExcel = createAction('[PE] export to Excel');
export const exportExcelSuccess = createAction('[PE] export to Excel success');
export const exportExcelFail = createAction('[PE] export to Excel fail', props<{ error: any }>());
